import React, { useEffect } from 'react';
import AppointmentForm from '../AppointmentForm';
import { useLocation } from 'react-router-dom';
import PageHero from '../PageHero';
import { useLanguage } from '../../context/LanguageContext';

const Appointment = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { t } = useLanguage();

  const preselectedBranch = location.state?.branch || searchParams.get('branch') || '';
  const preselectedService = location.state?.service || searchParams.get('service') || '';
  const preselectedDoctor = location.state?.doctor || searchParams.get('doctor') || '';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      {/* Attractive Hero Banner matching Branches.js */}
      <PageHero
        badge={t('nav.bookAppointment')}
        title={t('appointmentSection.pageTitle')}
        subtitle={t('appointmentSection.formSubtitle')}
      />

      {/* Main Form overlapping hero */}
      <div className="container mx-auto px-4 lg:px-8 -mt-16 md:-mt-20 relative z-20 pb-24">
        <div className="max-w-4xl mx-auto shadow-2xl rounded-2xl">
          <AppointmentForm 
            preselectedBranch={preselectedBranch}
            preselectedService={preselectedService}
            preselectedDoctor={preselectedDoctor}
          />
        </div>
      </div>
    </div>
  );
};

export default Appointment;
